import React, { Component } from 'react';
import { Grid, Header, Icon, Segment, Statistic, Message, Table } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { logGet } from '../../../util/api';
import Page from '../../../components/Page';
import moment from 'moment';
import { Bar } from 'react-chartjs-2';

class CartReminderAnalytic extends Component {
 state = {
   loading: true,
   data: null,
   error: null
 };

 componentDidMount() {
   this.fetchAnalytics();
 }

 componentDidUpdate(prevProps) {
   if (
     prevProps.start_date !== this.props.start_date ||
     prevProps.end_date !== this.props.end_date ||
     prevProps.newDataToggle !== this.props.newDataToggle
   ) {
     this.fetchAnalytics();
   }
 }

 fetchAnalytics = async () => {
  const { t } = this.props;
  
  try {
    const { start_date, end_date, product } = this.props;
    const pid = product?.id;

    const formattedStartDate = moment(start_date).format('YYYY-MM-DD');
    const formattedEndDate = moment(end_date).format('YYYY-MM-DD');

    const params = {
      time: formattedStartDate,
      pid
    };

    if (formattedStartDate !== formattedEndDate) {
      params.timeEnd = formattedEndDate;
    }

    const response = await logGet("/collectaction/cartReminderAnalytics", params);

    if (response.success && response.data.length > 0) {
      this.setState({
        data: response.data[0],
        loading: false,
        error: null
      });
    } else {
      this.setState({
        error: t('NoDataAvailable'),
        loading: false
      });
    }
  } catch (error) {
    this.setState({
      error: t('NoDataAvailable'),
      loading: false
    });
  }
};

 render() {
   const { loading, data, error } = this.state;
   const { t } = this.props;

   if (loading) return <Page.Loader />;
   
   if (error) {
    return (
      <div className="myContainer">
        <Message negative style={{ maxWidth: '1680px', margin: 'auto' }}>
          <Message.Header>{t('NoDataAvailable')}</Message.Header>
        </Message>
      </div>
    );
  }

   const chartData = {
     labels: [t('NoTemplateMessages'), t('TemplateMessages'), t('SendinBlueMessages')],
     datasets: [
       {
         label: t('Message Counts'),
         data: [
           data.no_template_message_count,
           data.template_message_count,
           data.sendinblue_count
         ],
         backgroundColor: [
           'rgba(255, 99, 132, 0.5)',
           'rgba(54, 162, 235, 0.5)',
           'rgba(75, 192, 192, 0.5)'
         ],
         borderColor: [
           'rgba(255, 99, 132, 1)',
           'rgba(54, 162, 235, 1)',
           'rgba(75, 192, 192, 1)'
         ],
         borderWidth: 1
       }
     ]
   };

   const chartOptions = {
     responsive: true,
     maintainAspectRatio: false,
     scales: {
       yAxes: [{
         ticks: {
           beginAtZero: true
         }
       }]
     }
   };

   return (
     <div className="myContainer">
       <Grid stackable>
         <Grid.Row columns={4}>
           <Grid.Column>
             <Segment textAlign="center">
               <Statistic>
                 <Statistic.Value>{data.no_template_message_count}</Statistic.Value>
                 <Statistic.Label>{t('NoTemplateMessages')}</Statistic.Label>
               </Statistic>
             </Segment>
           </Grid.Column>

           <Grid.Column>
             <Segment textAlign="center">
               <Statistic>
                 <Statistic.Value>{data.template_message_count}</Statistic.Value>
                 <Statistic.Label>{t('TemplateMessages')}</Statistic.Label>
               </Statistic>
             </Segment>
           </Grid.Column>
           
           <Grid.Column>
             <Segment textAlign="center">
               <Statistic>
                 <Statistic.Value>{data.sendinblue_count}</Statistic.Value>
                 <Statistic.Label>{t('SendinBlueMessages')}</Statistic.Label>
               </Statistic>
             </Segment>
           </Grid.Column>

           <Grid.Column>
             <Segment textAlign="center">
               <Statistic color="green">
                 <Statistic.Value>{data.collectaction_order_count || 0}</Statistic.Value>
                 <Statistic.Label>{t('ConvertedOrders')}</Statistic.Label>
               </Statistic>
             </Segment>
           </Grid.Column>
         </Grid.Row>

         <Grid.Row>
           <Grid.Column width={16}>
             <Segment style={{ height: '400px' }}>
               <Bar data={chartData} options={chartOptions} />
             </Segment>
           </Grid.Column>
         </Grid.Row>

         <Grid.Row>
           <Grid.Column width={16}>
             <Segment>
               <Header as="h3">
                 <Icon name="envelope" />
                 <Header.Content>
                   {t('MessageDetails')}
                   <Header.Subheader>
                     {t('Email')}: {data.email}
                   </Header.Subheader>
                 </Header.Content>
               </Header>
             </Segment>
           </Grid.Column>
         </Grid.Row>

         {data.order_details && data.order_details.length > 0 && (
           <Grid.Row>
             <Grid.Column width={16}>
               <Segment>
                 <Header as="h3">
                   <Icon name="shopping cart" />
                   <Header.Content>
                     {t('ConvertedOrderDetails')}
                     <Header.Subheader>
                       {t('OrdersCreatedFromCartReminders')}
                     </Header.Subheader>
                   </Header.Content>
                 </Header>
                 
                 <Table celled striped>
                   <Table.Header>
                     <Table.Row>
                       <Table.HeaderCell>{t('OrderNumber')}</Table.HeaderCell>
                       <Table.HeaderCell>{t('CustomerEmail')}</Table.HeaderCell>
                       <Table.HeaderCell>{t('PhoneNumber')}</Table.HeaderCell>
                     </Table.Row>
                   </Table.Header>
                   <Table.Body>
                     {data.order_details.map((order, index) => (
                       <Table.Row key={index}>
                         <Table.Cell>
                           <strong>{order.details.orderid}</strong>
                         </Table.Cell>
                         <Table.Cell>{order.details.mail}</Table.Cell>
                         <Table.Cell>{order.details.number}</Table.Cell>
                       </Table.Row>
                     ))}
                   </Table.Body>
                 </Table>
               </Segment>
             </Grid.Column>
           </Grid.Row>
         )}
       </Grid>
     </div>
   );
 }
}

const mapStateToProps = (state) => {
 return {
     product: state.product?.personalize
 };
};

export default connect(mapStateToProps)(withTranslation()(CartReminderAnalytic));